import React, { forwardRef } from 'react';
import { Typography, Stack, IconButton, useMediaQuery, Theme } from '@mui/material';

export const PageHeaderButton = forwardRef<
  HTMLButtonElement,
  { id: string; icon?: React.ReactNode; label?: string; onClick: (event: React.MouseEvent<HTMLElement>) => void }
>(({ id, icon, label, onClick }, ref) => {
  const mobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <IconButton
      id={id}
      ref={ref}
      aria-controls={id}
      aria-haspopup
      onClick={onClick}
      sx={{ py: '4px', pl: '4px', pr: mobileView || !label ? '4px' : '8px', borderRadius: '8px' }}
    >
      <Stack direction="row" alignItems="center" spacing="8px">
        {icon}
        {label && !mobileView && (
          <Typography sx={{ fontSize: '14px', color: '#000000', opacity: 0.87 }}>{label}</Typography>
        )}
      </Stack>
    </IconButton>
  );
});
